<template>
  <div>
    <NavBar/>
    <div class="min-height-page">
      <div class="container">
        <h1 class="text-center secondary-text mt-3">محصولات آموزش املاک</h1>
        <div v-if="isContentLoaded" class="row">
          <div v-for="item in products" :key="item.ProductId" class="col-md-4 col-sm-6 col-12">
            <ProductsCard :item="item"/>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <v-pagination
              v-if="hasPagination"
              v-model="pageIndex"
              :length="totalLength"
              :total-visible="24"
              :value="pageIndex"
              @input="onPageChange"
          ></v-pagination>
        </div>
      </div>
    </div>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import ProductsCard from "@/Academy/components/ProductsCard";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "allProducts",
  components: {FooterComponent, ProductsCard, NavBar},
  metaInfo () {
    return {
      title: window.projectName + this.typeTitle,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    products: [],
    isContentLoaded: false,
    showLoaderDialog: false,
    typeTitle: "محصولات",
    pageIndex: 1,
    totalLength: null,
    pageSize: null,
    hasPagination: false,

  }),
  watch: {
    '$route.query.type' () {
      location.reload()
    },
    "$route.query" () {
      if (this.$route.query.pageIndex !== undefined) {
        this.pageIndex = parseInt(this.$route.query.pageIndex);
      } else {
        this.pageIndex = 1;
      }
      this.getData();
    }
  },
  mounted () {
    this.getData()
    if (this.$route.query.pageIndex !== undefined) {
      this.pageIndex = parseInt(this.$route.query.pageIndex);
    }
  },
  methods: {
    onPageChange () {
      this.updateQueryFields("pageIndex", this.pageIndex, true);
    },
    updateQueryFields (key, value, isPageChanged = false) {
      const queryList = {};
      Object.assign(queryList, this.$route.query);
      queryList[key] = value;
      //this.$router.push({path: this.$route.path,query: { ...this.$route.query, data: 'load' } });

      if (!isPageChanged) {
        delete queryList.pageIndex;
      }
      this.$router.push({query: queryList});

    },
    getData () {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      let url = "/Client/Products?pageSize=24"

      if (this.$route.query.categoryID) {
        url += "&categoryId=" + this.$route.query.categoryID
      }

      if (this.typeSort !== undefined) {
        url += "&typeSort=" + this.typeSort;
      }

      if (this.$route.query.pageIndex !== undefined && this.$route.query.pageIndex !== "" && this.$route.query.pageIndex !== null) {
        url += "&pageIndex=" + this.$route.query.pageIndex;
      }
      /*if (this.pageSize !== null) {
        url += "&;
      }*/
      if(this.$route.query.type){
        url += "&typeProduct=" + this.$route.query.type
      }

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            let totalCount = json.totalCount;
            if (totalCount > 24) {
              this.totalLength = Math.ceil(totalCount / 24);
              this.hasPagination = true;
            } else {
              this.hasPagination = false;
            }
            this.products = json.list
            if (this.$route.query.type === "1") {
              this.typeTitle = 'محصولات فیزیکی'
            }
            if (this.$route.query.type === "0") {
              this.typeTitle = 'محصولات دیجیتال'
            }

            this.isContentLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>